module.exports = __webpack_public_path__ + "img/ic_wx_confirm_.ffcb1a0d.png";